import { useMemo } from 'react';
import { Link } from '@inertiajs/react';
import { marked } from 'marked';
import { Copyright } from 'lucide-react';
import Logo from '../../components/ui/Logo';
import ThemeToggle from '../../components/ui/ThemeToggle';

marked.setOptions({ breaks: true, gfm: true });

export default function Legal({ title, content }) {
  const html = useMemo(() => marked.parse(content || ''), [content]);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 flex flex-col">
      {/* Nav */}
      <nav className="flex items-center justify-between px-6 py-5 sm:px-10">
        <Link href="/" className="no-underline">
          <Logo className="h-8" />
        </Link>
        <ThemeToggle />
      </nav>

      {/* Content */}
      <main className="flex-1 w-full max-w-3xl mx-auto px-6 py-8 sm:px-10">
        <article
          className="prose prose-gray dark:prose-invert max-w-none"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </main>

      {/* Footer */}
      <footer className="py-6 text-center space-y-2">
        <div className="flex items-center justify-center gap-4 text-xs text-gray-400 dark:text-gray-500">
          <Link href="/privacy" className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors no-underline">
            Privacy
          </Link>
          <span>·</span>
          <Link href="/terms" className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors no-underline">
            Terms
          </Link>
        </div>
        <p className="inline-flex items-center gap-1 text-xs text-gray-400 dark:text-gray-500">
          <Copyright className="w-3.5 h-3.5" />
          StudyFit Inc
        </p>
      </footer>
    </div>
  );
}
